import React from "react";
/**will do more modification later */
export const renderBesicLabelPair = (info, defaultConfig) => {
    defaultConfig = defaultConfig ? defaultConfig : {};
    return (<><label {...info.titleLabel.attr} className={defaultConfig.tileCLass}>{info.titleLabel.text}</label><label {...info.detailLabel.attr}>{info.detailLabel.text || defaultConfig.defaultDetailTxt}</label></>)
}